import React from 'react';

import { Button, Text, VStack, theme } from '@squire/ui';

import { Page } from '@/components/_shared/Page';
import { useScreenTranslations } from '@/hooks/useScreenTranslations';

import { styles } from './styles';
import type { RescheduleAppointmentErrorFallbackProps } from './types';

const RescheduleAppointmentErrorFallback: React.FC<
  RescheduleAppointmentErrorFallbackProps
> = ({ resetErrorBoundary }) => {
  const { t } = useScreenTranslations('RescheduleAppointmentScreen');

  return (
    <Page edges={['top', 'bottom', 'left', 'right']} style={styles.container}>
      <VStack
        centerHorizontal
        centerVertical
        padding={theme.spacing[6]}
        space={theme.spacing[4]}
      >
        <VStack centerVertical space={theme.spacing[3]}>
          <Text variant="xlStrong" color="textPrimary" align="center">
            {t('error') as string}
          </Text>
        </VStack>
        {resetErrorBoundary && (
          <Button onPress={resetErrorBoundary} variant="primary">
            {t('tryAgain')}
          </Button>
        )}
      </VStack>
    </Page>
  );
};

RescheduleAppointmentErrorFallback.displayName =
  'RescheduleAppointmentErrorFallback';
export { RescheduleAppointmentErrorFallback };
